class FeatureCard extends HTMLElement {
  connectedCallback() {
    this.addEventListener('core-text:toggle', this.#onTextToggle);
  }

  disconnectedCallback() {
    this.removeEventListener('core-text:toggle', this.#onTextToggle);
  }

  #onTextToggle = (event) => {
    const truncate = event.target;
    if (!(truncate instanceof HTMLElement)) return;

    const coreText = truncate.closest('.core-text');
    if (!coreText || !this.contains(coreText)) return;

    const { expanded, collapsedHeight } = event.detail;
    const parent = coreText.parentElement;
    const parentIsRelative =
      parent != null && getComputedStyle(parent).position !== 'absolute';

    if (expanded) {
      if (!parentIsRelative) return;

      this.classList.add('is-text-expanded');
      coreText.classList.add('core-text--expand-anchor');
      coreText.style.height = `${collapsedHeight}px`;

      // Cap expanded text to the remaining card height so it scrolls instead of overflowing.
      requestAnimationFrame(() => {
        const cardRect = this.getBoundingClientRect();
        const truncateRect = truncate.getBoundingClientRect();
        const maxHeight = Math.max(0, Math.round(cardRect.bottom - truncateRect.top));
        truncate.style.maxHeight = `${maxHeight - 20}px`;
      });
      return;
    }

    this.classList.remove('is-text-expanded');
    coreText.classList.remove('core-text--expand-anchor');
    coreText.style.height = '';
    truncate.style.maxHeight = '';
  };
}

customElements.define('feature-card', FeatureCard);
